import { CHANGE_SIDEBAR_EXPAND } from '../types';

const initialState = {
  expanded: '0',
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type){
    case CHANGE_SIDEBAR_EXPAND:
      return {
        ...state,
        expanded: action.payload,
      };
    default:
      return state;
  }
}

export default sidebarReducer;